module.exports = __webpack_public_path__ + "static/media/HP-34F-Monitor.57bb70b2.jpg";